import React, { ComponentType, LazyExoticComponent } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { resourceType, webAppRoutes } from '../../constants';
import { BreadcrumbsLayout } from '../../layouts';
import { selectUser } from '../../store/reducers';
import { GuardedPage } from './guarded-page';

export interface RouteWithLayoutProps {
  roleAccessTypes?: string | string[];
  resourceType?: resourceType;
  breadcrumbsLayout?: boolean;
  component: LazyExoticComponent<ComponentType> | ComponentType;
}

export function GuardWithLayout(
  props: RouteWithLayoutProps,
): React.ReactElement {
  const { breadcrumbsLayout, component, roleAccessTypes, resourceType } = props;
  const Component = component as React.ElementType;

  const user = useSelector(selectUser);
  const noProtection = !resourceType;

  const getComponent = () =>
    breadcrumbsLayout ? (
      <BreadcrumbsLayout>
        <Component />
      </BreadcrumbsLayout>
    ) : (
      <Component />
    );

  if (!user) {
    return <Navigate to={webAppRoutes.signIn} />;
  }

  if (noProtection) {
    return getComponent();
  }

  return (
    <GuardedPage roleAccessTypes={roleAccessTypes} resourceType={resourceType}>
      {getComponent()}
    </GuardedPage>
  );
}
